import PropTypes from 'prop-types'
import './SchedularCalendarEvent.css'
import { schedularStatusStyles } from '../schedule-calendar/helper'

const StyledCard = ({ cardType, children, compact }) => {
  const styles = schedularStatusStyles[cardType] || schedularStatusStyles.SCHEDULED
  return (
    <div
      className={`flex h-full flex-col overflow-hidden rounded-md ${compact ? 'px-2 py-0.5' : 'px-2.5 py-2'}`}
      style={{
        backgroundColor: styles.backgroundColor,
        color: styles.color,
        borderLeft: `3px solid ${styles.borderColor}`
      }}
    >
      {children}
    </div>
  )
}

StyledCard.propTypes = {
  cardType: PropTypes.string,
  children: PropTypes.node,
  compact: PropTypes.bool
}

export const SchedularCalendarEvent = ({ type, timeText, fullName, vehicleYear, vehicleMake, repair_order_num, override, duration }) => {
  // Short (≤30 min) slots are only ~48px tall. Use a denser layout — smaller
  // fonts, tighter line-height, no inter-line margins — so time/name/vehicle all
  // fit instead of being clipped by the card's overflow-hidden.
  const isCompact = !!duration && duration <= 30

  if (override) {
    return (
      <StyledCard cardType='UNAVAILABLE' compact={isCompact}>
        <div className={compactCls(isCompact, 'font-bold', 'text-[10px] leading-none', 'text-[12px] leading-tight')}>Unavailable</div>
        <div className={compactCls(isCompact, 'opacity-90', 'text-[9px] leading-none', 'mt-1 text-[11px] leading-snug')}>
          Managed by Calendar Preferences
        </div>
      </StyledCard>
    )
  }

  const vehicleLine = [vehicleYear, vehicleMake].filter(Boolean).join(' ')

  return (
    <StyledCard cardType={type} compact={isCompact}>
      <div className={compactCls(isCompact, 'font-bold', 'text-[10px] leading-none', 'text-[12px] leading-tight')}>{timeText}</div>
      <div className={compactCls(isCompact, 'font-semibold truncate', 'text-[10px] leading-none', 'mt-0.5 text-[12px] leading-tight')}>
        {fullName}
      </div>
      {vehicleLine && (
        <div className={compactCls(isCompact, 'opacity-80 truncate', 'text-[10px] leading-none', 'mt-0.5 text-[11px] leading-tight')}>
          {vehicleLine}
        </div>
      )}
      {repair_order_num && <div className='mt-auto pt-2 text-[11px] leading-tight opacity-80'>RO #{repair_order_num}</div>}
    </StyledCard>
  )
}

// Joins the shared classes with either the compact or roomy size/spacing set.
const compactCls = (compact, base, compactSizing, roomySizing) => `${base} ${compact ? compactSizing : roomySizing}`

SchedularCalendarEvent.propTypes = {
  type: PropTypes.string,
  timeText: PropTypes.string,
  title: PropTypes.string,
  fullName: PropTypes.string,
  vehicleYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  vehicleMake: PropTypes.string,
  assingeeName: PropTypes.string,
  repair_order_num: PropTypes.string,
  isActive: PropTypes.bool,
  referralSource: PropTypes.string,
  override: PropTypes.bool,
  duration: PropTypes.number
}
